import { ColumnType } from '@/Types';
import { dateTimeUtils, stringUtils } from '@/Utils';

export function getColumnRender(columnType: ColumnType, value: string): string | boolean | number {
  if (+value == 0 && columnType === ColumnType.Currency) return (0).toCurrencyString();
  // devexpress converts undefined to NaN string value
  if (value == 'NaN' && columnType === ColumnType.Currency) return (0).toCurrencyString();

  if (!value || value == 'NaN') return '';

  switch (columnType) {
    case ColumnType.Decimal:
      return Number(stringUtils.normalizeToNumberString(value)).toDecimalString();

    case ColumnType.Currency:
      return Number(stringUtils.normalizeToNumberString(value)).toCurrencyString();

    case ColumnType.Boolean:
      return Boolean(value);

    case ColumnType.Number:
      return Number(value).toIntegerString();

    case ColumnType.DateTime:
      return dateTimeUtils.serverStringToLocalString(value, false);

    case ColumnType.Date:
      return dateTimeUtils.serverStringToLocalString(value, true);

    default:
      return String(value || '');
  }
}

export const getTypeByColumnInfo = (columnType?: ColumnType) => {
  switch (columnType) {
    case ColumnType.String:
    case ColumnType.Currency:
    case ColumnType.Weight:
      return 'string';

    case ColumnType.DateTime:
      return 'datetime';

    case ColumnType.Date:
      return 'date';

    case ColumnType.Number:
      return 'number';

    case ColumnType.Boolean:
      return 'boolean';

    default:
      return 'string';
  }
};

export const tableUtils = {
  getColumnRender,
  getTypeByColumnInfo,
};
